/* eslint-disable no-mixed-spaces-and-tabs */
import Axios from "axios";
// Actions
import {
	CHECK_PROMOTION_CODE,
	CREATE_CUSTOMER,
	CREATE_SOUSCRIPTION,
	setActivationCodeFlag,
	setAmountOff,
	setCustomerId,
	setPercentOff,
	setPromotionCodeFlag,
	setPromotionCodeId,
	UPDATE_CUSTOMER
} from "../actions/stripePayment";
import {saveUser, setErrorMessage, setRedirection, setSouscription} from "../actions/user";
// Utils
import {getApiBaseUrl} from "../utils/baseUrl";
import {getSession} from "../common/session.service";

const stripe = (store) => (next) => (action) => {
    switch (action.type) {
        // Action qui créé un "Customer" deans Stripe. Les utilisateurs créés peuvent être
        // retrouvés via le Dashboard du compte Stripe sous l'onglet "Client"
        case CREATE_CUSTOMER : {
            // Destructuring du State
            const state = store.getState();
            const {stripePayment, user} = state;
            const {userInfos} = stripePayment;
            const url = `${getApiBaseUrl()}/createCustomer/`;

            const payload = {
                "email": user.dataUser.email,
                "name": userInfos.firstname + " " + userInfos.lastname,
                "postal_code": userInfos.postalCode,
                "city": userInfos.city,
                "tel": userInfos.tel,
                "address": userInfos.address,
                "promotionCodeId": userInfos.promotionCodeId
            };

            Axios.post(url, payload)
                .then((res) => {
                    if (res) {
                        // Si l'utilisateur est créé, l'API renvoit le customerId Stripe
                        // On stock ce customerId dans le state ainsi que dans le localStorage
                        // Cet id servira à lié le user au potentiel paiement qu'il effectuera
                        // et ainsi avoir une trace via le Dashboard Stripe
                        store.dispatch(setCustomerId(res.data));
                        window.localStorage.setItem("customerId", res.data);

                        // On met à jour les informations du user en BDD par la même occasion
                        const urlToUpdateUser = `${getApiBaseUrl()}/updateUser/`;
                        const payloadToUpdateUser = {
                            "session": {
                                "id": window.localStorage.id,
                                "idUser": window.localStorage.idUser,
                                "email": window.localStorage.email,
                            },
                            "toUpdate": {
                                "idStripe": res.data, // -> customerId
                                "firstname": userInfos.firstname,
                                "name": userInfos.lastname,
                                "adress": userInfos.address,
                                "city": userInfos.city,
                                "cp": userInfos.postalCode,
                                "tel": userInfos.tel
                            }
                        };

                        Axios.post(urlToUpdateUser, payloadToUpdateUser)
                            .then(() => {
                                // Une fois les coordonnées mis à jour, on check que les information de la session sont correcte
                                const url = `${getApiBaseUrl()}/checkLogin/`;
                                Axios.post(url, getSession(), {withCredentials: true})
                                    .then((res) => {
                                        if (res.data.status === "success") {
                                            // On sauvegare les nouvelles coordonnée dans le state
                                            store.dispatch(saveUser(res.data.dataUser));
                                            store.dispatch(setRedirection(false));
                                        }
                                    });
                            });
                    }
                });

            next(action);
            break;
        }
        case UPDATE_CUSTOMER : {
            const state = store.getState();
            const {stripePayment, user} = state;
            const {userInfos, customerId} = stripePayment;
            const url = `${getApiBaseUrl()}/updateCustomer/`;
            const payload = {
                "email": user.dataUser.email,
                "name": userInfos.firstname + " " + userInfos.lastname,
                "postal_code": userInfos.postalCode,
                "city": userInfos.city,
                "tel": userInfos.tel,
                "address": userInfos.address,
                "promotionCodeId": userInfos.promotionCodeId,
                "customerId": customerId
            };
            Axios.post(url, payload)
                .then((res) => {
                    if (res) {
                        console.log(res, "réponse de ");
                        store.dispatch(setCustomerId(res.data));
                        window.localStorage.setItem("customerId", res.data);

                        const urlToUpdateUser = `${getApiBaseUrl()}/updateUser/`;

                        const payloadToUpdateUser = {
                            "session": {
                                "id": window.localStorage.id,
                                "idUser": window.localStorage.idUser,
                                "email": window.localStorage.email,
                            },
                            "toUpdate": {
                                "idStripe": res.data,
                                "firstname": userInfos.firstname,
                                "name": userInfos.lastname,
                                "adress": userInfos.address,
                                "city": userInfos.city,
                                "cp": userInfos.postalCode,
                                "tel": userInfos.tel
                            }
                        };

                        Axios.post(urlToUpdateUser, payloadToUpdateUser)
                            .then(() => {
                                const url = `${getApiBaseUrl()}/checkLogin/`;
                                Axios.post(url, getSession(), {withCredentials: true})
                                    .then((res) => {
                                        if (res.data.status === "success") {
                                            store.dispatch(saveUser(res.data.dataUser));
                                            store.dispatch(setRedirection(false));
                                        }
                                    });
                            });

                    }

                    // 	const urlToUpdateUser = `${getApiBaseUrl()}/updateUser/`;
                    //
                    // 	const payloadToUpdateUser = {
                    // 		"session": {
                    // 			"id": window.localStorage.id,
                    // 			"idUser": window.localStorage.idUser,
                    // 			"email": window.localStorage.email,
                    // 		},
                    // 		"toUpdate": {
                    // 			"idStripe": res.data,
                    // 		}
                    // 	};
                    //
                    // 	Axios.post(urlToUpdateUser, payloadToUpdateUser)
                    // 		.then((res) => res);
                    // }
                });

            next(action);
            break;
        }
        case CREATE_SOUSCRIPTION : {
            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
            };
            const url = `${getApiBaseUrl()}/createSouscription/`;

            Axios.post(url, payload)
                .then((res) => res);

            next(action);
            break;
        }
        case CHECK_PROMOTION_CODE : {
            const state = store.getState();
            const {stripePayment} = state;
            const myPromotionCode = stripePayment.promotionCode;
            window.localStorage.setItem("promotionCode", myPromotionCode);

            const url = `${getApiBaseUrl()}/checkPromotionCode/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "promotionCode": myPromotionCode
            };

            Axios.post(url, payload)
                .then((res) => {

                    const {data} = res;
                    if (data.status === "success") {
                        if (res.data.idExt && res.data.idSociete) {
                            console.log(res, "réponse de checkpromotioncode");
                            const urlUpdate = `${getApiBaseUrl()}/updateUser/`;
                            const payload = {
                                "session": {
                                    "id": window.localStorage.id,
                                    "idUser": window.localStorage.idUser,
                                    "email": window.localStorage.email,
                                },
                                "toUpdate": {
                                    "idExt": res.data.idExt,
                                    "idSociete": res.data.idSociete
                                }
                            };
                            Axios.post(urlUpdate, payload, {withCredentials: true}).then(() => {
                                store.dispatch(setSouscription(true));
                                store.dispatch(setActivationCodeFlag(true));
                            });
                        } else {
                            store.dispatch(setPromotionCodeId(data.id));
                            if (data.percent_off) {
                                store.dispatch(setPercentOff(data.percent_off));
                            }
                            if (data.amount_off) {
                                store.dispatch(setAmountOff(data.amount_off));
                            }
                            store.dispatch(setPromotionCodeFlag(true));
                        }


                    } else if (data.status === "error") {
                        store.dispatch(setErrorMessage("Code promo inconnu ou expiré"));
                        setTimeout(() => {
                            setErrorMessage("");
                        }, 5000);
                    }
                });
            next(action);
            break;
        }
        default:
            next(action);
    }
};

export default stripe;